/* @jsx h */
import { useMenu } from "@app/vue/providers/index";
import { defineComponent, ref, h, watch } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export const PickupDetailsSection = defineComponent({
  props: {
    show: Boolean,
  },
  setup(props) {
    const { cart } = useMenu();
    const { t } = useLocalization();
    const name = ref(cart.cart.pickupDetails?.name || "");
    const email = ref(cart.cart.pickupDetails?.email || "");
    const phone = ref(cart.cart.pickupDetails?.phone || "");

    const validateForm = () => {
      return (
        name.value.trim() !== "" &&
        email.value.trim() !== "" &&
        phone.value.trim() !== ""
      );
    };

    // Watch for changes and update cart
    watch([name, email, phone], ([newName, newEmail, newPhone]) => {
      if (!cart.cart.pickupDetails) {
        cart.cart.pickupDetails = {};
      }
      if (validateForm()) {
        cart.cart.pickupDetails.name = newName;
        cart.cart.pickupDetails.email = newEmail;
        cart.cart.pickupDetails.phone = newPhone;
      }
    });

    return () => (
      <div class={`p-2 ${!props.show ? "hidden" : ""}`}>
        <h3 class="text-lg font-semibold mb-4">
          {t("customer.checkout.pickup_details")}
        </h3>

        <div class="space-y-4">
          <div>
            <label class="label">
              <span class="label-text">{t("customer.checkout.name")}</span>
            </label>
            <input
              v-model={name.value}
              type="text"
              class="input input-bordered w-full"
              placeholder={t("customer.checkout.your_name")}
              required
            />
          </div>

          <div>
            <label class="label">
              <span class="label-text">{t("customer.checkout.email")}</span>
            </label>
            <input
              v-model={email.value}
              type="email"
              class="input input-bordered w-full"
              placeholder="your.email@example.com"
              required
            />
          </div>

          <div>
            <label class="label">
              <span class="label-text">{t("customer.checkout.phone")}</span>
            </label>
            <input
              v-model={phone.value}
              type="tel"
              class="input input-bordered w-full"
              placeholder="+41 XX XXX XX XX"
              required
            />
          </div>
        </div>
      </div>
    );
  },
});
